import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTheme = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 35.114,
	viewBox: "0 0 32 35.114",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(0.009 -0.009)",
		children: /* @__PURE__ */ _jsxs("g", {
			transform: "translate(-0.018)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M27,32H5.016a5,5,0,0,1-5-5V5a5.01,5.01,0,0,1,5-5h3a1,1,0,0,1,0,2h-3a3.007,3.007,0,0,0-3,3V27a3,3,0,0,0,3,3H27a3.008,3.008,0,0,0,3-3V26a1,1,0,0,1,2,0v1A5.011,5.011,0,0,1,27,32Z",
					transform: "translate(32.009 -0.009) rotate(90)",
					fill: "current"
				}),
				/* @__PURE__ */ _jsxs("g", {
					transform: "translate(960.577 -3046.647) rotate(45)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "M1503.675,2849.79a1.331,1.331,0,0,1-.948-.393l-2.6-2.6a2.979,2.979,0,0,1-.879-2.121l0-19.948a3,3,0,0,1,3-3h3.009a3,3,0,0,1,3,3v15.524a1,1,0,0,1-2,0v-15.524a1,1,0,0,0-1-1h-3.009a1,1,0,0,0-1,1l0,19.948a.992.992,0,0,0,.293.707l2.134,2.134,2.152-2.152a.993.993,0,0,0,.293-.707v-.714a1,1,0,0,1,2,0v.714a2.98,2.98,0,0,1-.879,2.121l-2.619,2.619A1.33,1.33,0,0,1,1503.675,2849.79Z",
							fill: "current"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M5.494,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H5.494a1,1,0,0,1,1,1A1,1,0,0,1,5.494,1Z",
							transform: "translate(1500.938 2826.781)",
							fill: "current"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M0,8.069a1,1,0,0,1-.707-.293,1,1,0,0,1,0-1.414L2.827,2.828A1,1,0,1,1,4.241,4.243L.707,7.777A1,1,0,0,1,0,8.069Z",
							transform: "translate(1511.031 2834.648)",
							fill: "current"
						})
					]
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M2147.011,6838.554h-14.345a1,1,0,0,1,0-2h14.345a1,1,0,0,1,0,2Z",
					transform: "translate(-2130.982 -6824.106)",
					fill: "current"
				})
			]
		})
	})
});
export { SvgTheme as ReactComponent };
